import { TokenHistoryLabel } from "kadow-jetpack-model";

export function isRequiredCtas(label: TokenHistoryLabel) {
    switch (label) {
        case TokenHistoryLabel.Share:
        case TokenHistoryLabel.Receipt:
            return true;

        default:
            return false;
    }
}